<template>
  <div class="pageSearchReservation">
    <h2>{{ $t("pages.wording.searchReserve") }}</h2>
    <!--預約單查詢-->
    <el-form label-width="150px">
      <h3>{{ $t("pages.wording.searchCondition") }}</h3>
      <!--查詢條件-->
      <div class="boxContain c-form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.deltaContactName')"
              ><!--deltaContactName-->
              <QueryEmpUser :model.sync="queryItems.deltaContactName" keyName="account" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.vendor')"
              ><!--公司名稱-->
              <el-input
                v-model="queryItems.vendor"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveNo')"
              ><!--單號-->
              <el-input
                v-model.trim="queryItems.reserveNo"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.oaCode')"
              ><!--OACode-->
              <el-autocomplete
                v-model="queryItems.OACode"
                :fetch-suggestions="queryOAcodeAsync"
                :placeholder="$t('pages.wording.placeholderInput')"
                clearable
              ></el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveArea')"
              ><!--抵達廠區-->
              <el-select
                :disabled="!enableAreaSelection"
                v-model="queryItems.reserveArea"
                :clearable="enableCancelSelected"
                :placeholder="$t('pages.wording.placeholderSelect')"
                @change="selectedArea"
              >
                <el-option v-for="item in base.areaBase" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.enterReason')" prop="enterReason"
              ><!--入廠事由-->
              <el-select
                v-model="queryItems.enterReason"
                clearable
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option
                  v-for="item in enterReasonBase"
                  :label="item[$i18n.locale]"
                  :value="item.code"
                  :key="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveFactory')" prop="reserveFactory"
              ><!--抵達廠別-->
              <el-select
                v-model="queryItems.reserveFactory"
                clearable
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option v-for="item in base.factoryBase" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('pages.wording.reserveStatus')" prop="reserveStatus"
              ><!--狀態-->
              <el-select
                v-model="queryItems.reserveStatus"
                clearable
                :placeholder="$t('pages.wording.placeholderSelect')"
              >
                <el-option :label="$t('reserve.status.cancel')" value="cancel"></el-option
                ><!--取消-->
                <el-option :label="$t('reserve.status.temporary')" value="temporary"></el-option
                ><!--暫存-->
                <el-option :label="$t('reserve.status.vendorComfirm')" value="vendorComfirm"></el-option
                ><!--待廠商確認-->
                <el-option :label="$t('reserve.status.entering')" value="entering"></el-option
                ><!--待進廠檢查-->
                <el-option :label="$t('reserve.status.in1')" value="in1"></el-option
                ><!--待出廠初檢-->
                <el-option :label="$t('reserve.status.in2')" value="in2"></el-option
                ><!--待出廠複檢-->
                <el-option :label="$t('reserve.status.finished')" value="finished"></el-option
                ><!--已完成-->
                <el-option :label="$t('reserve.status.enteringFail')" value="enteringFail"></el-option
                ><!--進廠檢查不合格-->
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('pages.wording').noteReserveQueryDatePeriod"
              placement="bottom"
            >
              <el-form-item :label="$t('pages.wording.reserveArriveDate')" prop="reserveDate"
                ><!--預約進廠日期-->
                <el-date-picker
                  v-model="queryItems.reserveArriveTime"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder="$t('pages.wording.startDate')"
                  :end-placeholder="$t('pages.wording.endDate')"
                  clearable
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  :editable="false"
                  ><!--開始日期/結束日期-->
                </el-date-picker>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="12">
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('pages.wording').noteReserveQueryDatePeriod"
              placement="bottom"
            >
              <el-form-item :label="$t('pages.wording.applyDate')" prop="createTime"
                ><!--申請時間-->
                <el-date-picker
                  v-model="queryItems.applyDatetime"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder="$t('pages.wording.startDate')"
                  :end-placeholder="$t('pages.wording.endDate')"
                  clearable
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  :editable="false"
                  ><!--開始日期/結束日期-->
                </el-date-picker>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
      <!--boxContain c-form-->
      <div class="buttons c-form">
        <el-button class="blue-button button-right" @click="sentApply" type="primary">{{
          $t("pages.button.search")
        }}</el-button
        ><!--查詢-->
        <el-button v-if="back" class="button-right" @click="cleanSearchVal" type="warning" style="margin-right: 10px">{{
          $t("pages.button.clean")
        }}</el-button
        ><!--清除-->
        <el-button
          class="blue-button button-right"
          style="margin-right: 10px"
          @click="exportInspectExcel"
          :disabled="exportInspectExcelIsLoading"
          :icon="exportInspectExcelIsLoading ? 'el-icon-loading' : ''"
          type="primary"
          >{{ $t("pages.button.exportInspectExcel") }}</el-button
        >
        <el-button
          class="blue-button button-right"
          @click="exportReserveExcel"
          :disabled="exportReserveExcelIsLoading"
          :icon="exportReserveExcelIsLoading ? 'el-icon-loading' : ''"
          type="primary"
          >{{ $t("pages.button.exportReserveExcel") }}</el-button
        >
      </div>
    </el-form>

    <h3>{{ $t("pages.wording.searchResult") }}</h3>
    <!--查詢結果-->
    <div class="boxContain c-table delta_table">
      <el-tabs v-model="activeName">
        <el-tab-pane label="preProcess" name="first">
          <span slot="label"><i class="el-icon-search"></i>{{ $t("pages.wording.searchResult") }}</span
          ><!--查詢結果-->
          <div class="s-table">
            <template>
              <el-table
                :data="reserveNewTable"
                ref="reserveResultTable"
                v-loading="loading"
                highlight-current-row
                @current-change="applyPageCheck"
                @sort-change="ReserveTableChangeSort"
                border
                style="width: 100%"
                height="450px"
              >
                <el-table-column :label="$t('pages.wording.action')" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <div v-if="!readOnly">
                      <el-button
                        v-if="
                          scope.row.reserveStatus == 'temporary' ||
                          scope.row.reserveStatus == 'vendorComfirm' ||
                          scope.row.reserveStatus == 'entering'
                        "
                        @click="reservationDelete(scope.row)"
                        type="text"
                        size="medium"
                      >
                        <i class="el-icon-delete"></i>
                      </el-button>
                      <el-button
                        v-if="
                          scope.row.reserveStatus == 'temporary' ||
                          scope.row.reserveStatus == 'vendorComfirm' ||
                          scope.row.reserveStatus == 'entering'
                        "
                        type="text"
                        size="medium"
                      >
                        <i class="el-icon-edit"></i>
                      </el-button>
                      <el-button v-else type="text" size="medium">
                        <i class="el-icon-tickets"></i>
                      </el-button>
                    </div>
                    <div v-if="readOnly">
                      <el-button @click="applyReserveInfo(scope.row)" type="text" size="medium">
                        <i class="el-icon-tickets"></i>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" :label="$t('pages.wording.oaCode')" width="80"> </el-table-column
                ><!--oaCode-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="130">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.reserveNo }}
                      <!-- <i class="el-icon-document-copy" @click="copyReserveNo(scope.row.reserveNo)"></i>  -->
                    </span></template
                  >
                </el-table-column>
                <el-table-column prop="releaseOrder" :label="$t('pages.wording.releaseOrder')" width="120">
                  <template
                    slot-scope="scope"
                    v-if="
                      (scope.row.reserveType == 'ERP' || scope.row.reserveType == 'ERP_ONE') &&
                      scope.row.reserveStatus != 'temporary'
                    "
                  >
                    <span class="releaseBtn" @click="getReleaseOrderList(scope.row)">{{
                      $t("pages.wording.releaseOrder")
                    }}</span>
                  </template> </el-table-column
                ><!--單號-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="150"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="driverName" :label="$t('pages.wording.driverName')" width="110"
                  ><!--駕駛員姓名-->
                  <template slot-scope="scope">
                    {{ !scope.row.tempCar ? scope.row.driverName : scope.row.tmpDriverName }}
                  </template>
                </el-table-column>
                <el-table-column prop="driverID" :label="$t('pages.wording.driverID')" width="100"
                  ><!--駕駛證號-->
                  <template slot-scope="scope">
                    {{ !scope.row.tempCar ? scope.row.driverID : scope.row.tmpDriverID }}
                  </template>
                </el-table-column>
                <el-table-column prop="carPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    {{ !scope.row.tempCar ? scope.row.carPlat : scope.row.tmpCarPlat }}
                  </template>
                </el-table-column>
                <el-table-column
                  :sortable="'custom'"
                  prop="reserveArriveDate"
                  :label="$t('pages.wording.reserveArriveDate')"
                  width="190"
                  ><!--預約進廠日期-->
                  <template slot-scope="scope">
                    {{
                      scope.row.reserveArriveDatetime != null
                        ? formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime)
                        : "NA"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="enteringDatetime" :label="$t('pages.wording.enteringTime')" width="160"
                  ><!--實際進廠時間-->
                  <template slot-scope="scope">
                    {{
                      scope.row.enteringDatetime != null
                        ? formateDatetimeStr("DateTime", scope.row.enteringDatetime)
                        : "NA"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="leaveDatetime" :label="$t('pages.wording.leaveDate')" width="180"
                  ><!--實際離廠時間-->
                  <template slot-scope="scope">
                    {{ scope.row.leaveDate != null ? formateDatetimeStr("DateTime", scope.row.leaveDatetime) : "NA" }}
                  </template>
                </el-table-column>
                <el-table-column prop="stayTime" :label="$t('pages.wording.stayTime')" width="120"
                  ><!--停車時間-->
                  <template slot-scope="scope">
                    {{ scope.row.stayTime != null ? scope.row.stayTime : "NA" }}
                  </template>
                </el-table-column>
                <el-table-column prop="reserveFactory" :label="$t('pages.wording.reserveFactory')" width="130">
                </el-table-column
                ><!--抵達廠區-->
                <el-table-column prop="enterReason" :label="$t('pages.wording.enterReason')" width="130">
                  <template slot-scope="scope" v-if="scope.row.reserveArriveDatetime != null">
                    {{ $store.getters.getSysCodeText("enterReason", scope.row.enterReason) }}
                  </template></el-table-column
                ><!--入廠是由-->
                <el-table-column
                  prop="deltaContactName"
                  label-class-name="header_label"
                  :label="$t('pages.wording.deltaContactName')"
                  minWidth="160"
                  maxWidth="220"
                >
                </el-table-column
                ><!--台達接洽人-->
                <el-table-column prop="stayTime" :label="$t('pages.wording.stayTime')" width="100"> </el-table-column
                ><!--停車時間-->
                <el-table-column prop="stayReason" :label="$t('pages.wording.stayReason')" width="130">
                  <template slot-scope="scope" v-if="scope.row.stayReason != null">
                    {{ $store.getters.getSysCodeText("delayReason", scope.row.stayReason) }}
                  </template> </el-table-column
                ><!--停車時間-->
                <el-table-column prop="reserveStatus" :label="$t('pages.wording.reserveStatus')" width="150"
                  ><!--狀態-->
                  <template slot-scope="scope">
                    {{ $t("reserve.status." + scope.row.reserveStatus) }}
                  </template>
                </el-table-column>
                <el-table-column
                  :sortable="'custom'"
                  prop="applyDate"
                  :label="$t('pages.wording.applyDate')"
                  width="120"
                >
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--填單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.reserveTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.reserveTablePage.pageTotal"
              @current-change="changePageReserveTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :title="$t('pages.wording.releaseOrder')" :visible.sync="dialog.releaseOrder" width="50%">
      <el-table
        class="dialogReleaseOrder"
        :data="releasTableData"
        border
        style="width: 90%"
        height="300px"
        @current-change="applyReleaseForm"
        :default-sort="{ prop: 'saleDate', order: 'descending' }"
      >
        <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseNumber')" width=""> </el-table-column
        ><!--廠別-->
        <el-table-column prop="so" label="SO No." width="100"> </el-table-column
        ><!--廠別-->
        <el-table-column prop="saleDate" :label="$t('pages.wording.salesDate')" width="120"> </el-table-column
        ><!--廠別-->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.releaseOrder = false">{{ $t("pages.button.confirm") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { store } from "@/store/store.js"
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
import { role } from "@/config/role.js"
import { mapGetters } from "vuex"
import QueryEmpUser from "@/components/common/QueryEmpUser"

export default {
  name: "PageSearchReservation",
  components: {
    QueryEmpUser,
  },
  props: ["back"],
  data() {
    let _minDate = null
    let _maxDate = null
    return {
      PermitQueryPeriodDays$: 91, //因endDate時間為23:59系統默認是隔天,所以必須加1天
      readOnly: false,
      activeName: "first",
      timeRange: null,
      pickerOptions: {
        disabledDate(time) {
          if (_minDate && _maxDate) {
            return time.getTime() < _minDate || time.getTime() > _maxDate
          }
        },
        onPick(time) {
          if (!time.maxDate) {
            let timeRange = 180 * 24 * 60 * 60 * 1000
            _minDate = time.minDate.getTime() - timeRange
            _maxDate = time.minDate.getTime() + timeRange
          } else {
            _minDate = _maxDate = null
          }
        },
      },
      queryItems: {
        deltaContactNT: "",
        deltaContactName: "",
        reserveRegion: "",
        reserveArea: "",
        reserveFactory: null,
        vendor: "",
        enterReason: "",
        applyDatetime: null,
        applyDatetimeStart: "",
        applyDatetimeEnd: "",
        reserveArriveTime: null,
        reserveArriveTimeStart: "",
        reserveArriveTimeEnd: "",
        reserveStatus: "",
        OACode: "",
        reserveNo: "",
      },
      reserveTable: [],
      releasTableData: [],
      reserveNewTable: [],
      reserveExcel: [],
      currentRow: null,
      rules: {},
      pages: {
        pageCount: 5,
        pageSize: 20,
        reserveTablePage: {
          pageTotal: 0,
          pageCurrent: 1,
        },
      },
      base: {
        areaBase: [],
        factoryBase: [],
      },
      dialog: {
        releaseOrder: false,
      },
      loading: false,
      enableAreaSelection: false,
      enableCancelSelected: false,
      exportReserveExcelIsLoading: false,
      exportInspectExcelIsLoading: false,
      enterReasonBase: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile", "getUserRoles"]),
    /***************-GENERAL-***************/
    init() {
      if (this.$props.back) this.initSearchVal()
      let userRoles = this.getUserRoles()
      let userRegion = this.getUserProfile().region
      let userArea = this.getUserProfile().area
      let userFactory = this.getUserProfile().factory
      if (this.getUserProfile().isAdmin) {
        this.enableCancelSelected = true
      }

      this.enableAreaSelection = this.getUserProfile().enableAreaSelection
      this.queryItems.reserveRegion = utils.getFirstOrDefault(userRegion)
      this.queryItems.reserveArea = utils.getFirstOrDefault(userArea)

      this.getFactory(this.queryItems.reserveRegion, this.queryItems.reserveArea, userFactory)
      this.getArea(this.queryItems.reserveRegion, userArea)
      this.getEnterReasonBase()

      if (userRoles.length === 1 && userRoles.includes(role.GUARD_LEAD)) {
        this.readOnly = true
      }
    },
    copyReserveNo(val) {
      window.event.stopPropagation()
      navigator.clipboard.writeText(val)
    },
    /***************-BASE-***************/
    getArea(region, area) {
      this.$store.dispatch("getArea", { region: region, area: area })
    },
    getFactory(region, area, factory) {
      this.$store.dispatch("getFactory", {
        region: region,
        area: area,
        factory: factory,
      })
    },
    /***************-KEEP-***********************/
    initSearchVal() {
      this.queryItems.deltaContactName = store.state.keepSearchReserve.deltaContactName
      this.queryItems.vendor = store.state.keepSearchReserve.vendor
      this.queryItems.reserveNo = store.state.keepSearchReserve.reserveNo
      this.queryItems.OACode = store.state.keepSearchReserve.OACode
      this.queryItems.reserveArea = store.state.keepSearchReserve.reserveArea
      this.queryItems.enterReason = store.state.keepSearchReserve.enterReason
      this.queryItems.reserveFactory = store.state.keepSearchReserve.reserveFactory
      this.queryItems.reserveStatus = store.state.keepSearchReserve.reserveStatus
      this.queryItems.applyDatetime = store.state.keepSearchReserve.applyDatetime
      this.queryItems.reserveArriveTime = store.state.keepSearchReserve.reserveArriveTime
    },
    keepSearchVal() {
      let parameter = {
        deltaContactName: this.queryItems.deltaContactName,
        vendor: this.queryItems.vendor,
        reserveNo: this.queryItems.reserveNo,
        OACode: this.queryItems.OACode,
        reserveArea: this.queryItems.reserveArea,
        enterReason: this.queryItems.enterReason,
        reserveFactory: this.queryItems.reserveFactory,
        reserveStatus: this.queryItems.reserveStatus,
        reserveArriveTime: this.queryItems.reserveArriveTime,
        applyDatetime: this.queryItems.applyDatetime,
        active: true,
      }
      this.$store.dispatch("KeepSearchReserve", parameter)
    },
    cleanSearchVal() {
      var parameter = {
        active: false,
      }
      this.$store.dispatch("KeepSearchReserve", parameter)
      this.initSearchVal()
    },
    /***************-PAGING-***************/
    changePageReserveTable(val) {
      this.reserveNewTable = utils.buildPagingTable(this.reserveTable, val, this.pages.pageSize)
    },
    ReserveTableChangeSort(cols) {
      utils.sortChangeMethod(cols, this.reserveTable)
      this.reserveNewTable = utils.buildPagingTable(
        this.reserveTable,
        this.pages.preProcessTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    /***************-FORM QUERY-***************/
    selectedArea(area) {
      this.getEnterReasonBase()
      let userFactory = this.getUserProfile().factory
      this.getFactory(this.queryItems.reserveRegion, area, userFactory)
      this.queryItems.reserveFactory = null
    },
    queryOAcodeAsync(inputString, cb) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let parameter = {
          oacode: inputString,
        }
        let cbData = []
        api
          .apiQueryOAcodeList({ params: parameter })
          .then((response) => {
            response.data.forEach((item) => {
              let tmp = {
                value: item,
              }
              cbData.push(tmp)
            })
            cb(cbData)
          })
          .catch((error) => {
            console.log(error)
          })
      }, 300)
    },
    applyPageCheck(val) {
      if (
        (val.reserveStatus == "vendorComfirm" || val.reserveStatus == "entering" || val.reserveStatus == "temporary") &&
        !this.readOnly
      )
        this.applyReserveTempForm(val)
      else this.applyReserveInfo(val)
    },
    applyReserveInfo(val) {
      let parameter = val
      parameter.parentName = "searchReserve"
      parameter.parent = true

      this.$router.push({
        name: "PageMyReservationInfo",
        params: parameter,
      })
    },
    checkAndGenerateParams() {
      let userAD = this.getUserProfile().userAD
      let parameter = {
        deltaContactName: this.queryItems.deltaContactName,
        reserveRegion: this.queryItems.reserveRegion,
        reserveArea: this.queryItems.reserveArea,
        reserveFactory: (this.queryItems.reserveFactory ?? "") === "" ? null : [this.queryItems.reserveFactory],
        vendor: this.queryItems.vendor,
        enterReason: this.queryItems.enterReason,
        reserveStatus:
          this.queryItems.reserveStatus === ""
            ? ["temporary", "cancel", "vendorComfirm", "entering", "in1", "in2", "finished", "enteringFail"]
            : [this.queryItems.reserveStatus],
        reserveNo: this.queryItems.reserveNo,
        OACode: this.queryItems.OACode,
        multi_arearole_query: this.getUserProfile().areaRights,
        userAD: userAD,
      }

      if (this.queryItems.applyDatetime != null && this.queryItems.applyDatetime.length != 0) {
        parameter.applyDatetimeStart = utils.getISOString(this.queryItems.applyDatetime[0] + " 00:00")
        parameter.applyDatetimeEnd = utils.getISOString(this.queryItems.applyDatetime[1] + " 23:59")
      }

      if (this.queryItems.reserveArriveTime != null && this.queryItems.reserveArriveTime.length != 0) {
        parameter.reserveArriveTimeStart = utils.getISOString(this.queryItems.reserveArriveTime[0] + " 00:00")
        parameter.reserveArriveTimeEnd = utils.getISOString(this.queryItems.reserveArriveTime[1] + " 23:59")
      }

      if (
        !utils.checkSearchPeriodRange(
          parameter.reserveArriveTimeStart,
          parameter.reserveArriveTimeEnd,
          this.PermitQueryPeriodDays$
        ) &&
        !utils.checkSearchPeriodRange(
          parameter.applyDatetimeStart,
          parameter.applyDatetimeEnd,
          this.PermitQueryPeriodDays$
        )
      ) {
        utils.showMessage(this, this.$t("message.alert").warnQueryDatePeriod)
        return { success: false }
      }
      return { success: true, params: parameter }
    },
    sentApply() {
      let vueInstance = this
      vueInstance.keepSearchVal()
      let checkResult = vueInstance.checkAndGenerateParams()
      if (!checkResult.success) {
        return
      }
      vueInstance.loading = true
      this.$refs.reserveResultTable.clearSort()
      this.$store.dispatch("getQueryReserveTable", checkResult.params)
    },
    exportReserveExcel() {
      let vueInstance = this
      let checkResult = vueInstance.checkAndGenerateParams()
      if (!checkResult.success) {
        return
      }
      vueInstance.exportReserveExcelIsLoading = true
      api
        .apiGetExportReserveTable(checkResult.params)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
          const link = document.createElement("a")
          link.href = URL.createObjectURL(blob)
          link.download = vueInstance.$t("pages.wording.searchReserve")
          link.click()
          vueInstance.exportReserveExcelIsLoading = false
          URL.revokeObjectURL(link.href)
        })
        .catch((error) => {
          console.error(error)
          vueInstance.exportReserveExcelIsLoading = false
        })
    },
    exportInspectExcel() {
      let vueInstance = this
      let checkResult = vueInstance.checkAndGenerateParams()
      if (!checkResult.success) {
        return
      }
      vueInstance.exportInspectExcelIsLoading = true
      api
        .apiGetExportInspectHistory(checkResult.params)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
          const link = document.createElement("a")
          link.href = URL.createObjectURL(blob)
          link.download = vueInstance.$t("pages.wording.inspectorForm")
          link.click()
          vueInstance.exportInspectExcelIsLoading = false
          URL.revokeObjectURL(link.href)
        })
        .catch((error) => {
          console.error(error)
          vueInstance.exportInspectExcelIsLoading = false
        })
    },
    reservationDelete(dataRow) {
      let e = window.event
      let vm = this
      e.stopPropagation()
      vm.$confirm(vm.$t("message.alert.warnDelete"))
        .then((_) => {
          let params = {
            reserveType: dataRow.reserveType,
            nowStatus: dataRow.reserveStatus,
            reserveID: dataRow.id,
            isPass: false,
          }
          utils.showLoading(vm)
          api
            .apiUpdateReserveFlow(params)
            .then((response) => {
              if (response.data) {
                utils.closeLoading(vm)
                if (response.data.success) {
                  vm.$message({
                    message: vm.$t("message.alert.successDelete"),
                    type: "success",
                  })
                  vm.sentApply()
                } else {
                  vm.$alert(vm.$t("pages.wording.occursWhenProcessReserveFlow"), "", {
                    confirmButtonText: vm.$t("pages.button.confirm"),
                  })
                }
              }
            })
            .catch((error) => {
              console.log(error)
              utils.closeLoading(vm)
            })
        })
        .catch((_) => {})
    },
    applyReserveTempForm(val) {
      let parameter = val
      parameter.parentName = "searchReserve"
      parameter.parent = true

      this.$router.push({
        name: "PageMyReservationTempForm",
        params: val,
      })
    },
    getReleaseOrderList(row) {
      let e = window.event
      e.stopPropagation()

      let parameter = {
        reserveRef: row.id,
      }
      this.$store.dispatch("getReleaseTable", parameter)
    },
    applyReleaseForm(val) {
      this.$router.push({
        name: "PageMyReleaseOrderForm",
        params: val,
      })
    },
    async getEnterReasonBase(val) {
      this.enterReasonBase = []

      if (val) {
        var res = await api.apiGetRegionAreaByFactory({ factory: this.queryItems.reserveFactory })
        if (res.data.region && res.data.area) {
          this.enterReasonBase = await utils.getCodeListWithCulture(res.data.region, res.data.area, "enterReason")
        }
      } else
        this.enterReasonBase = await utils.getCodeListWithCulture(
          "ALL",
          this.queryItems.reserveArea || "ALL",
          "enterReason"
        )

      //刷新選項後 不在選項內的要消除
      if (!this.enterReasonBase.some((x) => x.code == this.queryItems.enterReason)) {
        this.queryItems.enterReason = ""
      }
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  watch: {
    "$store.getters.alertMessage": function (val) {
      var code = val.code
      var message = val.message
      var cb = val.cb
      var title = "information"
      utils.alertMessage(this, code, message, title, cb)
    },
    "$store.getters.areaBase": function (val) {
      this.base.areaBase = val
    },
    "$store.getters.factoryBase": function (val) {
      this.base.factoryBase = val
    },
    "$store.getters.queryReserveTable": function (datas) {
      this.reserveTable = datas
      this.pages.reserveTablePage.pageTotal = this.reserveTable.length
      this.reserveNewTable = utils.buildPagingTable(
        this.reserveTable,
        this.pages.reserveTablePage.pageCurrent,
        this.pages.pageSize
      )
      this.loading = false
    },
    "$store.getters.releaseTable": function (val) {
      this.releasTableData = val
      this.dialog.releaseOrder = true
    },
    "queryItems.reserveFactory": function (val) {
      this.getEnterReasonBase(val)
    },
  },
}
</script>
